import { useEffect, useRef, useCallback, useState } from "react";

export default function useAutoSave(saveDraftLocal, intervalMs = 3000) {
  const [autoSaveStatus, setAutoSaveStatus] = useState("unsaved");
  const timerRef = useRef(null);
  const lastSaveRef = useRef(0);
  const saveRef = useRef(saveDraftLocal);
  saveRef.current = saveDraftLocal;

  const triggerSave = useCallback(() => {
    setAutoSaveStatus("unsaved");
    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      try {
        setAutoSaveStatus("saving");
        saveRef.current();
        lastSaveRef.current = Date.now();
        setAutoSaveStatus("saved");

      } catch {
        setAutoSaveStatus("unsaved");
      }
    }, intervalMs);
  }, [intervalMs]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return { autoSaveStatus, triggerSave };
}
